import { Row } from 'antd';
import styled from 'styled-components';

export const SurveyTopicContainer = styled(Row)`
  margin-top: 4rem;
  margin-bottom: 4rem;
`;

export const SurveyTopicTitle = styled.div`
  font-size: 1rem;
  letter-spacing: 0.2px;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.baseBlue.a8};
  text-align: center;
  font-weight: 600;
`;
